export default "__VITE_ASSET__2ab271d0__"